import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as ifaAddProductState from '../employee-detail.reducer';

